import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IState } from './type'
import { IStatusData, IArtist } from 'services/type'

const initialState: IState = {
  data: [],
  status: IStatusData.PENDING,
  currentPage: 0,
  totalPage: 0,
  totalItem: 0,
  pageSize: 10,
  isLoading: false,
}

export const artistSlice = createSlice({
  name: 'artist',
  initialState,
  reducers: {
    setData: (state: IState, action: PayloadAction<Array<IArtist>>) => {
      state.data = action.payload
    },
    editItem: (state: IState, action: PayloadAction<IArtist>) => {
      const index = state.data.findIndex(
        (obj) => obj.userId === action.payload.userId
      )
      if (index > -1) state.data[index] = action.payload
    },
    setStatus: (
      state: IState,
      action: PayloadAction<IStatusData | undefined>
    ) => {
      state.status = action.payload
    },
    setCurrentPage: (state: IState, action: PayloadAction<number>) => {
      state.currentPage = action.payload
    },
    setTotalPage: (state: IState, action: PayloadAction<number>) => {
      state.totalPage = action.payload
    },
    setTotalItem: (state: IState, action: PayloadAction<number>) => {
      state.totalItem = action.payload
    },
    setPageSize: (state: IState, action: PayloadAction<number>) => {
      state.pageSize = action.payload
    },
    setLoading: (state: IState, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
  },
})

export const {
  setLoading,
  setData,
  setStatus,
  editItem,
  setCurrentPage,
  setTotalPage,
  setPageSize,
  setTotalItem,
} = artistSlice.actions

export default artistSlice.reducer
